module.exports = __webpack_public_path__ + "img/background.28009756.png";